import { createVNode as l, mergeProps as a } from "vue";
import i from "../node_modules/@pf-ui/pf-icon-svg/es/asn/MaleOutlined.js";
import n from "../components/PfIcon.js";
const e = (t, r) => {
  const o = {
    ...t,
    ...r.attrs
  };
  return l(n, a(o, {
    icon: i
  }), null);
};
e.displayName = "MaleOutlined";
e.inheritAttrs = !1;
export {
  e as default
};
